/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Evidence_Partially_SupportedInputs */

const en_directory_evidence_partially_supported = /** @type {(inputs: Directory_Evidence_Partially_SupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partially verified`)
};

const zh_directory_evidence_partially_supported = /** @type {(inputs: Directory_Evidence_Partially_SupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部分验证`)
};

/**
* | output |
* | --- |
* | "Partially verified" |
*
* @param {Directory_Evidence_Partially_SupportedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_evidence_partially_supported = /** @type {((inputs?: Directory_Evidence_Partially_SupportedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Evidence_Partially_SupportedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_evidence_partially_supported(inputs)
	return zh_directory_evidence_partially_supported(inputs)
});
export { directory_evidence_partially_supported as "directory.evidence.partially_supported" }